import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { get } from 'lodash';

import { ActionTimeControl } from '../../ActionTimeControl/ActionTimeControl.jsx';
import { Clock } from '../../../icons';
import { MoreVertIconContrast } from '../../../icons/MoreVertIconContrast';
import { useStyles } from '../useStyles';
import { TYPES, useShowModal } from '../../../actions/modal';
import { getLastLeg } from '../../../selectors/screen';
import { onChangeTime } from '../../../actions/landing';
import { getPreviewWorkTime, getSubtotalWorkTime } from '../../../selectors/sended-data';
import { checkTimeIsCorrect } from '../../../service/NavPointsUtils';

export const EndWorkTime = memo(() => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { isLastLeg, value, workTime, timeWorkAfter, legWorkTime } = useSelector((state) => {
        const currentLeg = get(state, 'screen.currentLeg');
        const currentData = get(state, `sendedData[${currentLeg}]`, {});
        const landing = get(currentData, 'landing', {});
        const lastLeg = getLastLeg(state) || {};
        const isLastLeg = lastLeg.id === currentLeg;
        const previewWorkTime = getPreviewWorkTime(state);
        const subtotalWorkTime = getSubtotalWorkTime(state);

        return {
            value: landing.endWorkTime,
            isLastLeg,
            legWorkTime: previewWorkTime.workTime,
            timeWorkAfter: previewWorkTime.timeWorkAfter,
            workTime: subtotalWorkTime.workTime,
        };
    }, shallowEqual);
    const showModal = useShowModal();
    const { t: translate } = useTranslation();

    const handleChangeTime = React.useCallback((name, value) => {
        dispatch(onChangeTime(name, value));
    }, []);
    const title = isLastLeg ? translate('endInfoPage.endDutyTime') : translate('endInfoPage.endLegTime');
    const text = isLastLeg ? translate('endInfoPage.dutyTimeEnded') : translate('endInfoPage.legTimeEnded');

    const handleShowModal = React.useCallback((data) => {
        showModal(TYPES.DATE_TIME_PICKER, data);
    }, []);

    const summaryInfo = React.useMemo(() => {
        const res = [];

        if (timeWorkAfter) {
            res.push({
                title: translate('endInfoPage.postFlightTime'),
                value: timeWorkAfter,
                isCorrect: checkTimeIsCorrect(timeWorkAfter),
            });
        }

        res.push({
            title: translate('endInfoPage.dutyTimeLeg'),
            value: legWorkTime,
            isCorrect: checkTimeIsCorrect(legWorkTime),
        });

        res.push({
            title: isLastLeg ? translate('endInfoPage.dutyTime') : translate('endInfoPage.subtotalDutyTime'),
            value: workTime,
            isCorrect: checkTimeIsCorrect(workTime),
        });

        return res;
    }, [workTime, timeWorkAfter, isLastLeg, legWorkTime, translate]);

    return (
        <div className={classes.actionTime}>
            <ActionTimeControl
                title={title}
                buttonName={title}
                state="ENTER_COMPLETED"
                iconButton={<Clock width="22" height="22" />}
                iconMenuImg={<MoreVertIconContrast isContrast={true} />}
                text={text}
                name="endWorkTime"
                value={value}
                summary={summaryInfo}
                onChange={handleChangeTime}
                showModal={handleShowModal}
            />
        </div>
    );
});
